import { getEndpoint } from "@api-routes/endpoint";

const ADJUSTMENTS_MS_NAME = "adjustments";
export const getAdjustmentDetailsRoute = (reference: string) =>
    `${getEndpoint(ADJUSTMENTS_MS_NAME)}adjustment/${reference}`;
